var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { ArrowBack, InsertLinkOutlined, MoreVert, Search } from '@mui/icons-material';
import { Avatar, Grid, LinearProgress, Typography, useMediaQuery } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { DownloadSvgIcon, PrintSvgIcon, ShareLineSvgIcon } from '../../../assets/customIcons';
import { GreenVerifiedTick } from '../../../assets/images';
import { DynamicFormBuilderContainer } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container';
import { FormItemTypes } from '../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity';
import { MuiStack } from '../../../components';
import StatusColor from '../../../components/atoms/statusColor';
import { LOCAL_STORAGE_KEYS } from '../../../constants';
import { showNewNotification } from '../../../redux/commonSlice';
import { resetState } from '../../../redux/crudSlice';
import { systemColor } from '../../../theme/systemColor';
import { getLocalStorageItem } from '../../../utils/storageHelper';
import { dateFormate, isLoadingState } from '../../../utils/utils';
import { BasicDetailcards } from '../../spareIssue/components/basicDetailCards';
import { getSearchDisable } from '../../spareIssue/utils/utils';
import PartDetails from '../components/partDetails';
import { getFilterTypeList, getPartDetailsAPICall, getSearchResultAPIcall } from '../services/apiCalls';
import { APIKeys, SpareIssueReturnKeys } from '../services/entity';
var CreateSpareIssueReturn = function () {
    var _crud$SpareIssueRetur, _crud$SpareIssueRetur3, _crud$SpareIssueRetur4, _crud$SpareIssueRetur5, _crud$SpareIssueRetur6, _crud$SpareIssueRetur7, _crud$SpareIssueRetur8, _crud$SpareIssueRetur9, _crud$SpareIssueRetur10, _crud$SpareIssueRetur11, _crud$SpareIssueRetur12, _crud$SpareIssueRetur13, _crud$SpareIssueRetur14, _crud$SpareIssueRetur15, _crud$SpareIssueRetur16, _crud$SpareIssueRetur17, _crud$SpareIssueRetur18, _crud$profilePersonal;
    var navigate = useNavigate();
    var dispatch = useDispatch();
    var id = useParams().id;
    var isMobile = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var searchParams = useSearchParams()[0];
    var selectedBranch = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH);
    var crud = useSelector(function (state) { return state.crud; });
    var getSearchByTypeList = crud.getSearchByTypeList;
    var data = crud[SpareIssueReturnKeys === null || SpareIssueReturnKeys === void 0 ? void 0 : SpareIssueReturnKeys.SpareIssueReturnDetails] || crud[SpareIssueReturnKeys === null || SpareIssueReturnKeys === void 0 ? void 0 : SpareIssueReturnKeys.Get];
    var mode = searchParams.get('mode');
    var _a = useState(false), isFormVisible = _a[0], setIsFormVisible = _a[1];
    var _b = useState(false), isOpen = _b[0], setIsOpen = _b[1];
    var primaryContact = crud === null || crud === void 0 || (_crud$SpareIssueRetur = crud[SpareIssueReturnKeys.CustomerAssociationDetails]) === null || _crud$SpareIssueRetur === void 0 || (_crud$SpareIssueRetur = _crud$SpareIssueRetur.data) === null || _crud$SpareIssueRetur === void 0 || (_crud$SpareIssueRetur = _crud$SpareIssueRetur.PersonContactPoint) === null || _crud$SpareIssueRetur === void 0 ? void 0 : _crud$SpareIssueRetur.find(function (item) { return (item === null || item === void 0 ? void 0 : item.ContactType) === "Primary"; });
    var _c = useState(''), searchValue = _c[0], setSearchValue = _c[1];
    var _d = useState("All"), filterType = _d[0], setFilterType = _d[1];
    var _e = useState(), installbaseData = _e[0], searchedIstallbaseData = _e[1];
    var isSearchDisabled = getSearchDisable(filterType, searchValue);
    useEffect(function () {
        getFilterTypeList({});
    }, []);
    useEffect(function () {
        var _crud$SpareIssueRetur2;
        if ((_crud$SpareIssueRetur2 = crud[SpareIssueReturnKeys.SearchDetails]) !== null && _crud$SpareIssueRetur2 !== void 0 && _crud$SpareIssueRetur2.data //  && crud[SpareIssueReturnKeys.JobcardDetails]?.data && 
        //  crud[SpareIssueReturnKeys.CustomerAssociationDetails]?.data &&
        //   crud[SpareIssueReturnKeys.PartDetails]?.data
        ) {
            setIsFormVisible(true);
        }
    }, [crud[SpareIssueReturnKeys.SearchDetails], crud[SpareIssueReturnKeys.JobcardDetails], crud[SpareIssueReturnKeys.CustomerAssociationDetails], crud[SpareIssueReturnKeys.PartDetails]]);
    var handleSearchIconClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, _response$data$, request;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, getSearchResultAPIcall({
                        request: (_a = {},
                            _a[filterType] = searchValue,
                            _a)
                    })];
                case 1:
                    response = _b.sent();
                    if (!(response !== null && response !== void 0 && response.success || (response === null || response === void 0 ? void 0 : response.statusCode) === 200)) return [3 /*break*/, 3];
                    searchedIstallbaseData(response === null || response === void 0 ? void 0 : response.data);
                    request = {
                        JobCardId: response !== null && response !== void 0 && response.data ? response === null || response === void 0 || (_response$data$ = response.data[0]) === null || _response$data$ === void 0 ? void 0 : _response$data$.JobCardId : '',
                        TenantId: selectedBranch.OrganizationId
                    };
                    if (!response.data[0].JobCardId) return [3 /*break*/, 3];
                    return [4 /*yield*/, getPartDetailsAPICall({
                            request: request
                        })];
                case 2:
                    _b.sent();
                    _b.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var getInstallbase = function (state, value) { return __awaiter(void 0, void 0, void 0, function () {
        var _partsResonse, _response6, response, partsResonse, _response, _response2, _response3, _response4, _response5, request;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    partsResonse = {};
                    console.log("state", state);
                    if (!(state !== null && state !== void 0 && state.Key && state !== null && state !== void 0 && state.Value)) return [3 /*break*/, 3];
                    return [4 /*yield*/, getSearchResultAPIcall({
                            request: (_a = {},
                                _a[state.Key] = state === null || state === void 0 ? void 0 : state.Value,
                                _a)
                        })];
                case 1:
                    response = _b.sent();
                    if (!((_response = response) !== null && _response !== void 0 && _response.success || ((_response2 = response) === null || _response2 === void 0 ? void 0 : _response2.statusCode) === 200)) return [3 /*break*/, 3];
                    searchedIstallbaseData((_response3 = response) === null || _response3 === void 0 ? void 0 : _response3.data);
                    request = {
                        JobCardId: (_response4 = response) !== null && _response4 !== void 0 && _response4.data ? (_response5 = response) === null || _response5 === void 0 || (_response5 = _response5.data[0]) === null || _response5 === void 0 ? void 0 : _response5.JobCardId : '',
                        TenantId: selectedBranch.OrganizationId
                    };
                    if (!response.data[0].JobCardId) return [3 /*break*/, 3];
                    return [4 /*yield*/, getPartDetailsAPICall({
                            request: request
                        })];
                case 2:
                    partsResonse = _b.sent();
                    _b.label = 3;
                case 3:
                    console.log("partsResonse?.data", (_partsResonse = partsResonse) === null || _partsResonse === void 0 ? void 0 : _partsResonse.data);
                    return [2 /*return*/, _objectSpread({}, (_response6 = response) === null || _response6 === void 0 ? void 0 : _response6.data)];
            }
        });
    }); };
    var partElements = [{
            type: FormItemTypes.ContainerItem,
            name: '',
            rowSpacing: 2,
            columnSpacing: 2,
            columnSize: 12,
            elements: [{
                    type: FormItemTypes.Box,
                    name: '',
                    sx: {
                        bgcolor: 'secondary.50',
                        borderRadius: '8px',
                        border: '1px solid ',
                        borderColor: 'secondary.200'
                    },
                    padding: '8px 12px ',
                    gap: '4px',
                    display: 'flex',
                    flexDirection: 'column',
                    columnSize: 12,
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: 'UnitOfMeasurementName',
                            label: 'UOM: ',
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between',
                                alignItems: 'baseline',
                                gap: 1
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm'
                            },
                            fontWeight: 'medium',
                            fontSize: 'sm',
                            columnSize: 12,
                            setFormState: function (formValues) {
                                console.log('form values ', formValues);
                                return formValues;
                            }
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'ProductName',
                            label: 'Issued Location:',
                            value: '',
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between',
                                alignItems: 'baseline',
                                gap: 1
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm'
                            },
                            fontWeight: 'medium',
                            fontSize: 'sm',
                            columnSize: 12
                        }, {
                            type: FormItemTypes.Typography,
                            name: '',
                            label: 'Previous return qty:',
                            value: '',
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between',
                                alignItems: 'baseline',
                                gap: 1
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm'
                            },
                            fontWeight: 'medium',
                            fontSize: 'sm',
                            columnSize: 12
                        }, {
                            type: FormItemTypes.Typography,
                            name: '',
                            label: 'Available qty for return:',
                            value: '',
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between',
                                alignItems: 'baseline',
                                gap: 1
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm'
                            },
                            fontWeight: 'medium',
                            fontSize: 'sm',
                            columnSize: 12
                        }, {
                            type: FormItemTypes.Typography,
                            name: '',
                            label: 'Return qty:',
                            value: '',
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between',
                                alignItems: 'baseline',
                                gap: 1
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm'
                            },
                            fontWeight: 'medium',
                            fontSize: 'sm',
                            columnSize: 12
                        }, {
                            type: FormItemTypes.Typography,
                            name: '',
                            label: 'Purchase cost (₹):',
                            value: '',
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between',
                                alignItems: 'baseline',
                                gap: 1
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm'
                            },
                            fontWeight: 'medium',
                            fontSize: 'sm',
                            columnSize: 12
                        }, {
                            type: FormItemTypes.Typography,
                            name: '',
                            label: 'Total cost (₹):',
                            value: '',
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between',
                                alignItems: 'baseline',
                                gap: 1
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm'
                            },
                            fontWeight: 'medium',
                            fontSize: 'sm',
                            columnSize: 12
                        }]
                }, {
                    type: FormItemTypes.SearchSelect,
                    label: 'Reason',
                    name: 'ReasonId',
                    // getListData: getTechnicianList,
                    apiKey: 'technicianList',
                    // apiRequest: { WorkingOrganizationId: documentDetailsGetById?.data?.OrganizationId },
                    valueExpr: 'id',
                    displayExpr: 'FirstName',
                    setFormState: function (formValues) {
                        console.log('form values ', formValues);
                        return formValues;
                    }
                }, {
                    type: FormItemTypes.TextInput,
                    name: 'Amount',
                    label: 'Remarks (0/200 characters)',
                    placeholder: 'Enter remarks...',
                    value: null,
                    multiline: true,
                    maxLength: 200,
                    minRows: 2,
                    columnSize: 6,
                    xs: 12,
                    sm: 6,
                    md: 3,
                    // disabled: isDisabled ?? false,
                    setFieldProps: function (formValues, value) {
                        var _value$length;
                        return {
                            type: this.type,
                            label: "Remarks (".concat((_value$length = value === null || value === void 0 ? void 0 : value.length) !== null && _value$length !== void 0 ? _value$length : 0, "/200 characters)")
                        };
                    }
                    // setFormState:(formValues)=>{console.log('form values ', formValues)
                    //     return formValues
                    // }
                }]
        }];
    var General = [isFormVisible ? {
            type: FormItemTypes.Accordian,
            name: 'BasicDetails',
            columnSize: 12,
            value: false,
            summaryProps: {
                sx: {
                    display: "flex",
                    alignItems: "flex-start",
                    position: "relative",
                    paddingTop: 2
                }
            },
            sx: {
                border: '1px',
                borderRadius: "12px",
                borderColor: "#DEE4EB"
            },
            setFormState: function (formValues, currValue) {
                setIsOpen(currValue);
                return {};
            },
            summary: [{
                    type: FormItemTypes.Typography,
                    name: 'Basic Details',
                    children: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Typography, {
                        fontSize: "14px",
                        fontWeight: "600",
                        pt: 0
                    }, "Basic details"), !isOpen && /*#__PURE__*/ React.createElement(Grid, {
                        container: true,
                        spacing: 2,
                        pt: 2
                    }, /*#__PURE__*/ React.createElement(Grid, {
                        item: true,
                        md: 4,
                        sm: 6,
                        xs: 12
                    }, /*#__PURE__*/ React.createElement(Typography, {
                        fontSize: "12px",
                        fontWeight: "500",
                        color: "#6A7682",
                        lineHeight: "18px",
                        pb: 1
                    }, "Customer details"), /*#__PURE__*/ React.createElement(MuiStack, {
                        justifyContent: "space-between",
                        sx: {
                            width: "100%",
                            height: "48px",
                            alignItems: 'center',
                            display: 'flex',
                            gap: 1,
                            borderColor: "#DEE4EB"
                        },
                        border: 1,
                        borderRadius: "8px"
                    }, /*#__PURE__*/ React.createElement(MuiStack, {
                        alignItems: 'center',
                        gap: "8px",
                        pl: "8px"
                    }, /*#__PURE__*/ React.createElement(Avatar, {
                        alt: "Riya Raheja",
                        sx: {
                            width: "24px",
                            height: "24px"
                        }
                    }), /*#__PURE__*/ React.createElement(Typography, {
                        fontSize: "14px",
                        lineHeight: "20px",
                        fontWeight: "500"
                    }, (crud === null || crud === void 0 || (_crud$SpareIssueRetur3 = crud[SpareIssueReturnKeys.CustomerAssociationDetails]) === null || _crud$SpareIssueRetur3 === void 0 ? void 0 : _crud$SpareIssueRetur3.data) && (crud === null || crud === void 0 || (_crud$SpareIssueRetur4 = crud[SpareIssueReturnKeys.CustomerAssociationDetails]) === null || _crud$SpareIssueRetur4 === void 0 || (_crud$SpareIssueRetur4 = _crud$SpareIssueRetur4.data) === null || _crud$SpareIssueRetur4 === void 0 || (_crud$SpareIssueRetur4 = _crud$SpareIssueRetur4.Person) === null || _crud$SpareIssueRetur4 === void 0 ? void 0 : _crud$SpareIssueRetur4.GivenName) + " " + (crud === null || crud === void 0 || (_crud$SpareIssueRetur5 = crud[SpareIssueReturnKeys.CustomerAssociationDetails]) === null || _crud$SpareIssueRetur5 === void 0 || (_crud$SpareIssueRetur5 = _crud$SpareIssueRetur5.data) === null || _crud$SpareIssueRetur5 === void 0 || (_crud$SpareIssueRetur5 = _crud$SpareIssueRetur5.Person) === null || _crud$SpareIssueRetur5 === void 0 ? void 0 : _crud$SpareIssueRetur5.FamilyName))), /*#__PURE__*/ React.createElement(MuiStack, {
                        alignItems: 'center',
                        gap: "4px",
                        pr: "8px"
                    }, /*#__PURE__*/ React.createElement(Typography, {
                        fontSize: "12px",
                        lineHeight: "18px",
                        fontWeight: "400",
                        color: "#8593A3"
                    }, crud !== null && crud !== void 0 && (_crud$SpareIssueRetur6 = crud[SpareIssueReturnKeys.CustomerAssociationDetails]) !== null && _crud$SpareIssueRetur6 !== void 0 && _crud$SpareIssueRetur6.data && crud !== null && crud !== void 0 && (_crud$SpareIssueRetur7 = crud[SpareIssueReturnKeys.CustomerAssociationDetails]) !== null && _crud$SpareIssueRetur7 !== void 0 && (_crud$SpareIssueRetur7 = _crud$SpareIssueRetur7.data) !== null && _crud$SpareIssueRetur7 !== void 0 && _crud$SpareIssueRetur7.MobileNumber ? crud === null || crud === void 0 || (_crud$SpareIssueRetur8 = crud[SpareIssueReturnKeys.CustomerAssociationDetails]) === null || _crud$SpareIssueRetur8 === void 0 || (_crud$SpareIssueRetur8 = _crud$SpareIssueRetur8.data) === null || _crud$SpareIssueRetur8 === void 0 ? void 0 : _crud$SpareIssueRetur8.MobileNumber : "-"), primaryContact && (primaryContact === null || primaryContact === void 0 ? void 0 : primaryContact.IsMobileVerified) && /*#__PURE__*/ React.createElement("img", {
                        src: GreenVerifiedTick,
                        id: "viewButton",
                        alt: "grayIcon",
                        height: "12px"
                    })))), /*#__PURE__*/ React.createElement(Grid, {
                        item: true,
                        md: 4,
                        sm: 6,
                        xs: 12
                    }, /*#__PURE__*/ React.createElement(Typography, {
                        fontSize: "12px",
                        fontWeight: "500",
                        color: "#6A7682",
                        lineHeight: "18px",
                        pb: 1
                    }, "Job card details"), /*#__PURE__*/ React.createElement(MuiStack, {
                        justifyContent: "space-between",
                        sx: {
                            width: "100%",
                            height: "48px",
                            alignItems: 'center',
                            display: 'flex',
                            gap: 1,
                            borderColor: "#DEE4EB"
                        },
                        border: 1,
                        borderRadius: "8px"
                    }, /*#__PURE__*/ React.createElement(MuiStack, {
                        alignItems: 'center',
                        gap: "8px",
                        pl: "8px"
                    }, /*#__PURE__*/ React.createElement(Typography, {
                        fontSize: "14px",
                        lineHeight: "20px",
                        fontWeight: "500"
                    }, ((_crud$SpareIssueRetur9 = crud[SpareIssueReturnKeys.JobcardDetails]) === null || _crud$SpareIssueRetur9 === void 0 || (_crud$SpareIssueRetur9 = _crud$SpareIssueRetur9.data) === null || _crud$SpareIssueRetur9 === void 0 ? void 0 : _crud$SpareIssueRetur9.Code) || "-")), /*#__PURE__*/ React.createElement(MuiStack, {
                        alignItems: 'center',
                        gap: "4px",
                        pr: "8px"
                    }, /*#__PURE__*/ React.createElement(Typography, {
                        fontSize: "12px",
                        lineHeight: "18px",
                        fontWeight: "400",
                        color: "#8593A3"
                    }, (_crud$SpareIssueRetur10 = crud[SpareIssueReturnKeys.JobcardDetails]) !== null && _crud$SpareIssueRetur10 !== void 0 && (_crud$SpareIssueRetur10 = _crud$SpareIssueRetur10.data) !== null && _crud$SpareIssueRetur10 !== void 0 && _crud$SpareIssueRetur10.JobCardDate ? dateFormate((_crud$SpareIssueRetur11 = crud[SpareIssueReturnKeys.JobcardDetails]) === null || _crud$SpareIssueRetur11 === void 0 || (_crud$SpareIssueRetur11 = _crud$SpareIssueRetur11.data) === null || _crud$SpareIssueRetur11 === void 0 ? void 0 : _crud$SpareIssueRetur11.JobCardDate) : "-")))), /*#__PURE__*/ React.createElement(Grid, {
                        item: true,
                        md: 4,
                        sm: 6,
                        xs: 12
                    }, /*#__PURE__*/ React.createElement(Typography, {
                        fontSize: "12px",
                        fontWeight: "500",
                        color: "#6A7682",
                        lineHeight: "18px",
                        pb: 1
                    }, "Vehicle details"), /*#__PURE__*/ React.createElement(MuiStack, {
                        justifyContent: "space-between",
                        sx: {
                            width: "100%",
                            height: "48px",
                            alignItems: 'center',
                            display: 'flex',
                            gap: 1,
                            borderColor: "#DEE4EB"
                        },
                        border: 1,
                        borderRadius: "8px"
                    }, /*#__PURE__*/ React.createElement(MuiStack, {
                        alignItems: 'center',
                        gap: "8px",
                        pl: "8px"
                    }, /*#__PURE__*/ React.createElement(Typography, {
                        fontSize: "14px",
                        lineHeight: "20px",
                        fontWeight: "500"
                    }, (_crud$SpareIssueRetur12 = crud[SpareIssueReturnKeys.InstallbaseDetails]) !== null && _crud$SpareIssueRetur12 !== void 0 && (_crud$SpareIssueRetur12 = _crud$SpareIssueRetur12.data) !== null && _crud$SpareIssueRetur12 !== void 0 && _crud$SpareIssueRetur12.RegistrationNo ? (_crud$SpareIssueRetur13 = crud[SpareIssueReturnKeys.InstallbaseDetails]) === null || _crud$SpareIssueRetur13 === void 0 || (_crud$SpareIssueRetur13 = _crud$SpareIssueRetur13.data) === null || _crud$SpareIssueRetur13 === void 0 ? void 0 : _crud$SpareIssueRetur13.RegistrationNo : "-")), /*#__PURE__*/ React.createElement(MuiStack, {
                        alignItems: 'center',
                        gap: "4px",
                        pr: "8px"
                    }, /*#__PURE__*/ React.createElement(Typography, {
                        fontSize: "12px",
                        lineHeight: "18px",
                        fontWeight: "400",
                        color: "#8593A3"
                    }, (_crud$SpareIssueRetur14 = crud[SpareIssueReturnKeys.InstallbaseDetails]) !== null && _crud$SpareIssueRetur14 !== void 0 && (_crud$SpareIssueRetur14 = _crud$SpareIssueRetur14.data) !== null && _crud$SpareIssueRetur14 !== void 0 && _crud$SpareIssueRetur14.ProductName ? "".concat((_crud$SpareIssueRetur15 = crud[SpareIssueReturnKeys.InstallbaseDetails]) === null || _crud$SpareIssueRetur15 === void 0 || (_crud$SpareIssueRetur15 = _crud$SpareIssueRetur15.data) === null || _crud$SpareIssueRetur15 === void 0 ? void 0 : _crud$SpareIssueRetur15.ProductName, "(").concat((_crud$SpareIssueRetur16 = crud[SpareIssueReturnKeys.InstallbaseDetails]) === null || _crud$SpareIssueRetur16 === void 0 || (_crud$SpareIssueRetur16 = _crud$SpareIssueRetur16.data) === null || _crud$SpareIssueRetur16 === void 0 ? void 0 : _crud$SpareIssueRetur16.ProductCode, ")") : "-")))))),
                    fontSize: 'md',
                    columnSize: 12,
                    fontWeight: 'strong'
                }],
            elements: [{
                    type: FormItemTypes.Box,
                    name: '',
                    columnSize: 12,
                    sx: {
                        p: 2
                    },
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            columnSize: 0,
                            children: /*#__PURE__*/ React.createElement(BasicDetailcards, null),
                            fontSize: 'lg',
                            fontWeight: 'strong'
                        }]
                }]
        } : null, isFormVisible && isMobile ? {
            type: FormItemTypes.Accordian,
            name: 'part',
            label: '',
            value: null,
            sx: {
                borderRadius: '12px'
            },
            summaryProps: {
                sx: {
                    paddingInline: '12px',
                    justifyContent: 'center',
                    alignItems: 'center'
                }
            },
            summary: [{
                    type: FormItemTypes.Box,
                    name: '',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: 'partDetail',
                            label: '',
                            value: null,
                            children: 'Parts',
                            columnSize: 0,
                            variant: "h5"
                        }, {
                            type: FormItemTypes.Chip,
                            name: 'count',
                            color: 'info',
                            sx: {
                                ml: '4px'
                            },
                            valueGetter: function (formValues, field) {
                                var _formValues$partDetai;
                                return (formValues === null || formValues === void 0 || (_formValues$partDetai = formValues.partDetails) === null || _formValues$partDetai === void 0 ? void 0 : _formValues$partDetai.length) || 0;
                            },
                            setFieldProps: function (formValues, currValue) {
                                var _formValues$partDetai2, _formValues$partDetai3;
                                return {
                                    type: FormItemTypes.Chip,
                                    sx: {
                                        display: ((_formValues$partDetai2 = formValues === null || formValues === void 0 || (_formValues$partDetai3 = formValues.partDetails) === null || _formValues$partDetai3 === void 0 ? void 0 : _formValues$partDetai3.length) !== null && _formValues$partDetai2 !== void 0 ? _formValues$partDetai2 : 0) > 0 ? 'inline-flex' : 'none',
                                        ml: '4px'
                                    }
                                };
                            }
                        }]
                }],
            elements: [{
                    type: FormItemTypes.SearchSelect,
                    name: 'Parts',
                    // getListData: getPartList,
                    apiKey: 'partList',
                    multiple: true,
                    renderTags: function () { return null; },
                    clearText: 'Clear Selected Parts',
                    columnSize: true,
                    placeholder: 'Enter part name code',
                    displayExpr: 'Name',
                    valueExpr: 'id',
                    setFormState: function (state, value) {
                        var _value$at, _value$at2, _value$at3, _value$at4;
                        if (!(value !== null && value !== void 0 && value.length))
                            return {};
                        return {
                            partDetails: __spreadArray(__spreadArray([], value.slice(0, -1), true), [{
                                    ChildName: (_value$at = value.at(-1)) === null || _value$at === void 0 ? void 0 : _value$at.Name,
                                    ChildId: (_value$at2 = value.at(-1)) === null || _value$at2 === void 0 ? void 0 : _value$at2.ProductId,
                                    id: (_value$at3 = value.at(-1)) === null || _value$at3 === void 0 ? void 0 : _value$at3.ProductId,
                                    ChildCode: (_value$at4 = value.at(-1)) === null || _value$at4 === void 0 ? void 0 : _value$at4.SkuCode
                                }], false)
                        };
                    },
                    valueGetter: function (state) { return state.partDetails; }
                }, {
                    type: FormItemTypes.Button,
                    name: 'More',
                    children: /*#__PURE__*/ React.createElement(MoreVert, null),
                    size: 'small',
                    variant: 'outlined',
                    color: 'secondary',
                    sx: {
                        p: '7px'
                    },
                    columnSize: 0
                }, {
                    type: FormItemTypes.Divider,
                    name: '',
                    sx: {
                        color: 'text.secondary'
                    },
                    columnSize: 12
                }, {
                    type: FormItemTypes.List,
                    name: 'partsDetailsList',
                    // variant: 'comfortable',
                    columnSize: 12,
                    value: [{
                            "_id": "33c5b045-5480-47ff-9111-c5e8aad39b57",
                            "id": "33c5b045-5480-47ff-9111-c5e8aad39b57",
                            "SchemaId": "0ffdbd01-218f-4681-92fd-cde59effb50f",
                            "PartitionKey": "177881c0-4f30-41f0-a949-a7df2fa63d8a",
                            "CreatedOn": "2024-09-30T10:11:32.914Z",
                            "CreatedBy": "1d5f87ed-324d-4456-a230-30b27bfd5c78",
                            "UpdatedOn": "2025-03-06T09:40:35.690Z",
                            "UpdatedBy": "16bbd637-2451-4061-9e70-4a03de187baf",
                            "_type": "JobCardDetail",
                            "_ts": "2025-03-06T09:40:35.690Z",
                            "JobCardDetailId": "33c5b045-5480-47ff-9111-c5e8aad39b57",
                            "JobCardId": "ba742b49-31ff-4a45-aabe-4318dc7ea3eb",
                            "EntityId": "e8672fd9-2b81-4070-bc5f-72913cc6dd45",
                            "ChildId": "303d1b68-3b89-4f31-95ed-ebd368e692a9",
                            "UnitOfMeasurementId": "c4c9e92c-72d7-4564-8abd-1e6cebb76809",
                            "StatusId": "0e2ab118-7ce9-4727-a5f6-8453d0d5ff45",
                            "JobCardServiceGroup": 1,
                            "Quantity": 1,
                            "IsActive": true,
                            "IsDeleted": false,
                            "IsOutsideLabour": false,
                            "ServiceGroupId": "1ab0536e-cbda-4f88-b46f-8d6e674cbfa7",
                            "Price": null,
                            "ServiceTypeId": "21dacac4-c139-4da9-98e0-f916d3ad4c95",
                            "ServiceStationTypeId": null,
                            "ServiceStartDateTime": null,
                            "ServiceEndDateTime": null,
                            "ExpectedStartDateTIme": null,
                            "ExpectedEndDateTIme": null,
                            "ReworkStartDateTime": null,
                            "ReworkEndDateTime": null,
                            "ChildCode": "DY161210",
                            "ChildName": "CABLE CLUTCH",
                            "AllocatedQty": 0,
                            "IsAutoFill": false,
                            "AutofillType": null,
                            "HSNSACId": null,
                            "Description": null,
                            "ApprovalStatusId": null,
                            "CWIApprovalId": null,
                            "CWIRejectReasonId": null,
                            "ReasonForPendencyId": null,
                            "RMApprovalDate": null,
                            "RMServiceApprovalStatusId": null,
                            "RMServiceRemarks": null,
                            "Remarks": null,
                            "ASMActivityDate": null,
                            "UBApprovedASMUserId": null,
                            "UBASMApprovedDateTime": null,
                            "IsASMApproved": null,
                            "DefectId": null,
                            "SOHPercentage": null,
                            "IsPaidPartWarranty": null,
                            "IsMoreThanThreeTimesWarranty": null,
                            "SpareIssueStatusId": null,
                            "IsEngine": null,
                            "IsBS6": null,
                            "BatterySerialNumber": null,
                            "Source": null,
                            "OldComponentSerialNumber": null,
                            "ICC_ID": null,
                            "IMEI_ID": null,
                            "ReEstimateStatusId": null,
                            "IsGRNDone": null,
                            "GRNDoneFromUtility": null,
                            "IssuedQuantity": 0,
                            "AvailableQuantity": 0,
                            "OnHandQuantity": 0,
                            "PendingQuantity": 0,
                            "NotIssuedQuantity": null,
                            "ReturnedQuantity": null,
                            "CancelQuantity": null,
                            "ReworkId": null,
                            "OutsideSupplierId": null,
                            "OutsideWorkPurchaseOrderId": null,
                            "OutsideRemarks": null,
                            "ServiceTypeName": "Fourth Free Service-3W",
                            "UnitOfMeasurementName": "EACH",
                            "ProductName": "CABLE CLUTCH",
                            "ChildSystemName": "Product",
                            "SKUCode": "DY161210",
                            "RequestedQuantity": 1,
                            "IssueQuantity": 0,
                            "DefaultInventoryTrackingType": "Serialized",
                            "HSNSACCode": "87141090",
                            "LocationDetails": [{
                                    "ProductId": "303d1b68-3b89-4f31-95ed-ebd368e692a9",
                                    "LocationId": "73656d71-80a8-4b54-815e-00e4b600532b",
                                    "QuantityOnPurchaseOrder": 0,
                                    "QuantityOnTransit": 0,
                                    "QuantityAvailable": 0,
                                    "WarehouseId": "66aac928-8855-4421-83d2-27fd79e2cfd2",
                                    "OnHandQuantity": 0,
                                    "ProjectedQuantity": 0,
                                    "id": "73656d71-80a8-4b54-815e-00e4b600532b",
                                    "LocationName": "Default",
                                    "WarehouseName": "Default",
                                    "DamageQuantity": 0,
                                    "LocationCode": "LCN-0000000000069"
                                }, {
                                    "ProductId": "303d1b68-3b89-4f31-95ed-ebd368e692a9",
                                    "LocationId": "5436b80d-c5a9-4370-a0c3-8179348122d8",
                                    "QuantityOnPurchaseOrder": 0,
                                    "QuantityOnTransit": 0,
                                    "QuantityAvailable": 0,
                                    "WarehouseId": "2a00e105-02d6-4674-8b5c-841088ed286f",
                                    "OnHandQuantity": 0,
                                    "ProjectedQuantity": 0,
                                    "id": "5436b80d-c5a9-4370-a0c3-8179348122d8",
                                    "LocationName": "Default",
                                    "WarehouseName": "Default2",
                                    "LocationCode": "LCN-0000000000069"
                                }],
                            "ProjectedQuantity": 0,
                            "Code": "DY161210",
                            "RatioBilling": [],
                            "JobCardBillingRatio": [],
                            "PriceDetail": {
                                "Price": 0,
                                "Type": "Base",
                                "IsEditable": true,
                                "IsConfigured": false,
                                "Rate": 0
                            },
                            "HSNCode": "87141090"
                        }],
                    // apiKey:'partDetailsGet',
                    containerProps: {
                        sx: {
                            mb: '16px'
                        }
                    },
                    // apiKey: SpareIssueReturnKeys.PartDetails,
                    columns: [{
                            field: 'Part',
                            flex: 1,
                            renderCell: function (_ref) {
                                var row = _ref.row;
                                return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Typography, {
                                    variant: "h3"
                                }, row.ChildName), /*#__PURE__*/ React.createElement(Typography, {
                                    variant: "h6",
                                    color: "secondary"
                                }, row.ChildCode ? '#' + row.ChildCode : ''));
                            }
                        }],
                    elements: partElements
                }],
            detailPanelProps: {
                sx: {
                    paddingInline: '12px'
                }
            },
            columnSize: 12
        } : isFormVisible ? {
            type: FormItemTypes.Custom,
            name: 'partsDetailsList',
            element: PartDetails,
            columnSize: 12
        } : null];
    var AdditionalInformation = [{
            type: FormItemTypes.CardComponent,
            name: 'AdditionalInfo',
            label: 'Notes & attachments',
            value: null,
            variant: 'outlined',
            columnSize: 12,
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    label: '',
                    value: null,
                    spacing: 2,
                    marginTop: 0,
                    columnSize: 12,
                    elements: [{
                            type: FormItemTypes.TextInput,
                            name: 'ReturnBy',
                            label: 'Returned by'
                        }, {
                            type: FormItemTypes.SearchSelect,
                            name: 'Reason',
                            label: 'Reason'
                        }, {
                            type: FormItemTypes.TextInput,
                            name: 'Remarks',
                            label: 'Remarks (0/200 characters)',
                            placeholder: 'Enter remarks...',
                            value: null,
                            multiline: true,
                            maxLength: 200,
                            minRows: 2,
                            columnSize: 6,
                            xs: 12,
                            sm: 6,
                            md: 3,
                            // disabled: isDisabled ?? false,
                            setFieldProps: function (formValues, value) {
                                var _value$length2;
                                return {
                                    type: this.type,
                                    label: "Remarks (".concat((_value$length2 = value === null || value === void 0 ? void 0 : value.length) !== null && _value$length2 !== void 0 ? _value$length2 : 0, "/200 characters)")
                                };
                            }
                        }, {
                            type: FormItemTypes.Attachment,
                            name: 'Attachments',
                            label: 'Add attachments',
                            placeholder: 'Upload Files',
                            // disabled: isDisabled ?? false,
                            value: [],
                            inputProps: {
                                accept: 'application/*',
                                multiple: true
                            }
                            // uploadAttachmentRequest: { systemname: WorkPurchaseInvoiceKeys.AttachmentSystemName },
                            // uploadAttachmentAPI: uploadPurchaseInvoiceAttachment,
                            // deleteAttachmentAPI: purchaseInvoiceAttachmentDelete,
                        }]
                }]
        }];
    var tabs = [{
            id: '0',
            label: 'General',
            elements: General,
            containerProps: {
                paddingX: 2
            }
        }, {
            id: '3',
            label: 'Additional info',
            elements: AdditionalInformation,
            containerProps: {
                paddingX: 2
            }
        }];
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: "pageHeader",
            columnSize: 12,
            justifyContent: "space-between",
            alignItems: "center",
            spacing: 0,
            gap: 1,
            p: 2,
            elements: [{
                    type: FormItemTypes.IconButton,
                    name: "",
                    columnSize: 0,
                    children: /*#__PURE__*/ React.createElement(ArrowBack, {
                        fontSize: "small",
                        onClick: function () {
                            dispatch(resetState(APIKeys)), navigate('/workPurchaseInvoice');
                        }
                    })
                }, {
                    type: FormItemTypes.Typography,
                    name: '',
                    children: mode == 'edit' ? 'Spare issue return' : 'New spare issue return',
                    columnSize: 0,
                    variant: "h1",
                    noWrap: true
                }, {
                    type: FormItemTypes.Custom,
                    name: "",
                    columnSize: 0,
                    element: function () { return data !== null && data !== void 0 && data.StatusName ? /*#__PURE__*/ React.createElement(MuiStack, {
                        sx: {
                            border: "1px solid #DEE4EB",
                            borderRadius: "6px",
                            gap: "5px",
                            padding: "3px 8px"
                        },
                        alignItems: "center"
                    }, /*#__PURE__*/ React.createElement(StatusColor, {
                        status: ''
                    }), /*#__PURE__*/ React.createElement(Typography, {
                        id: "statusKeyId",
                        variant: "h6"
                    }, data === null || data === void 0 ? void 0 : data.StatusName)) : /*#__PURE__*/ React.createElement(React.Fragment, null); }
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: true,
                    item: false,
                    justifyContent: 'end',
                    spacing: 0,
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: 'DocumentNumber',
                            label: 'DOC NO: ',
                            columnSize: 0,
                            labelTypographyProps: {
                                color: 'rgba(0,0,0,0.4)',
                                fontSize: 12,
                                fontWeight: 500,
                                mb: 0
                            },
                            containerProps: {
                                display: 'flex',
                                direction: 'row',
                                alignItems: 'center',
                                spacing: 0,
                                gap: 1,
                                px: 1
                            },
                            fontWeight: 400,
                            fontSize: 12
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'DocumentDate',
                            label: 'DOC DATE: ',
                            valueGetter: function (formData) {
                                return dateFormate(formData === null || formData === void 0 ? void 0 : formData.DocumentDate);
                            },
                            columnSize: 0,
                            labelTypographyProps: {
                                color: 'rgba(0,0,0,0.4)',
                                fontSize: 12,
                                fontWeight: 500,
                                mb: 0
                            },
                            containerProps: {
                                display: 'flex',
                                direction: 'row',
                                alignItems: 'center',
                                spacing: 0,
                                gap: 1,
                                px: 1
                            },
                            fontWeight: 400,
                            fontSize: 12
                        }]
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: 'ActionPanel',
            columnSize: 12,
            spacing: 0,
            columnSpacing: 2,
            p: 2,
            minWidth: '100%',
            flexDirection: 'row',
            justifyContent: 'space-between',
            bgcolor: '#EFF2F5',
            setFieldProps: function (formValues, currValue) {
                return {
                    type: this.type
                    // display: { xs: 'none', sm: 'flex' }
                };
            },
            elements: [mode === 'add' ? {
                    type: FormItemTypes.TextInput,
                    name: 'JobCardNo',
                    value: (_crud$SpareIssueRetur17 = (_crud$SpareIssueRetur18 = crud[SpareIssueReturnKeys.SpareIssueDetails]) === null || _crud$SpareIssueRetur18 === void 0 || (_crud$SpareIssueRetur18 = _crud$SpareIssueRetur18.data) === null || _crud$SpareIssueRetur18 === void 0 ? void 0 : _crud$SpareIssueRetur18.TransactionNo) !== null && _crud$SpareIssueRetur17 !== void 0 ? _crud$SpareIssueRetur17 : '',
                    maxLength: 30,
                    columnSize: 4.5,
                    focused: false,
                    disabled: true,
                    style: {
                        borderRadius: "8px",
                        background: "#fff",
                        marginLeft: 9.6
                    },
                    sx: {
                        '& .MuiOutlinedInput-root': {
                            paddingLeft: 0
                        }
                    }
                } :
                    // {
                    //     type: FormItemTypes.TextInput,
                    //     name: 'TransactionNo',
                    //     value: !isNullOrEmpty(searchValue) ? searchValue : null,
                    //     maxLength: 30,
                    //     placeholder: "Search customer by VIN, reg no, job card no",
                    //     xs: 12,
                    //     sm: 5,
                    //     md: 4.5,
                    //     // columnSize: 4.5,
                    //     focused: false,
                    //     onChange: (e: any, value) => {
                    //         setSearchValue(e?.target?.value)
                    //         if (value === "" || value === null || value === undefined) setIsFormVisible(false);
                    //         if (!e?.target?.value) {
                    //             dispatch(setReducerState({ key: SpareIssueReturnKeys.PartDetails, value: null }))
                    //             dispatch(setReducerState({ key: SpareIssueReturnKeys.JobcardDetails, value: null }))
                    //             dispatch(setReducerState({ key: SpareIssueReturnKeys.SearchDetails, value: null }))
                    //         }
                    //     },
                    //     style: {
                    //         borderRadius: "8px",
                    //         background: "#fff",
                    //     },
                    //     sx: {
                    //         '& .MuiOutlinedInput-root': {
                    //             paddingLeft: 0,
                    //         },
                    //     },
                    //     InputProps: {
                    //         startAdornment:
                    //             <MuiStack borderRight={'1px solid #DEE4EB'} mx={2} width={'120px'}>
                    //                 <Select
                    //                     defaultValue={getSearchByTypeList?.[0]?.Value ?? ''}
                    //                     sx={{
                    //                         "& fieldset": {
                    //                             border: 'none',
                    //                             boxShadowColor: 'none',
                    //                             "&:root": {
                    //                                 border: 'none',
                    //                                 boxShadow: 'none',
                    //                             }
                    //                         },
                    //                     }}
                    //                     className='custume-select-auto'
                    //                     value={filterType}
                    //                     onChange={(e: any, value: any) => {
                    //                         setSearchValue('')
                    //                         setFilterType(value?.props?.id)
                    //                     }}
                    //                     id={'searchVehicleDropDown'}
                    //                 >
                    //                     {getSearchByTypeList?.map((item: any, index: number) => (
                    //                         <MenuItem id={item.Value} key={index} value={item.Value}>
                    //                             {item.DisplayName}
                    //                         </MenuItem>
                    //                     ))}
                    //                 </Select>
                    //             </MuiStack>
                    //         ,
                    //         endAdornment:
                    //             <IconButton onClick={handleSearchIconClick} disabled={isSearchDisabled} sx={{ opacity: isSearchDisabled ? 0.4 : "none" }}>
                    //                 <img src={SearchIcon} alt="" />
                    //             </IconButton>
                    //     }
                    // },
                    {
                        type: FormItemTypes.ContainerItem,
                        name: 'actions',
                        xs: 12,
                        sm: 5,
                        md: 4.5,
                        spacing: 0,
                        elements: [{
                                type: FormItemTypes.Stack,
                                name: 'actions',
                                direction: 'row',
                                alignItems: 'center',
                                columnGap: 0.5,
                                borderRadius: 2,
                                px: 1.25,
                                py: 0.5,
                                border: '1px solid',
                                borderColor: 'secondary.300',
                                bgcolor: 'white',
                                width: '100%',
                                maxWidth: 400,
                                elements: [{
                                        type: FormItemTypes.SingleSelect,
                                        name: 'Key',
                                        apiKey: SpareIssueReturnKeys.SearchByTypeList,
                                        options: crud[SpareIssueReturnKeys.SearchByTypeList],
                                        value: null,
                                        valueExpr: 'Value',
                                        displayExpr: 'DisplayName',
                                        variant: 'standard',
                                        disableUnderline: true,
                                        sx: {
                                            minWidth: 90
                                        },
                                        columnSize: 0
                                    }, {
                                        type: FormItemTypes.TextInput,
                                        name: 'Value',
                                        columnSize: true,
                                        variant: 'standard',
                                        placeholder: 'Search by Reg No, VIN, Mobile, Email',
                                        InputProps: {
                                            disableUnderline: true
                                        },
                                        valueSetter: function (state, currValue, field) {
                                            var _a;
                                            return (_a = {},
                                                _a[field.name] = currValue === null || currValue === void 0 ? void 0 : currValue.trim(),
                                                _a);
                                        }
                                    }, {
                                        type: FormItemTypes.IconButton,
                                        name: 'searchButton',
                                        columnSize: 0,
                                        color: 'secondary',
                                        children: /*#__PURE__*/ React.createElement(Search, {
                                            color: "secondary"
                                        }),
                                        setFormState: getInstallbase
                                    }]
                            }]
                    }, {
                    type: FormItemTypes.ContainerItem,
                    name: "",
                    label: "",
                    value: null,
                    columnSize: true,
                    item: false,
                    justifyContent: "end",
                    spacing: 1,
                    alignItems: 'center',
                    setFieldProps: function (formValues, currValue) {
                        return {
                            type: this.type,
                            display: {
                                xs: 'none',
                                sm: 'flex'
                            }
                        };
                    },
                    elements: [{
                            type: FormItemTypes.Button,
                            name: "",
                            children: "Quick Links",
                            columnSize: 0,
                            variant: "text",
                            startIcon: /*#__PURE__*/ React.createElement(InsertLinkOutlined, null),
                            color: 'secondary'
                        }, {
                            type: FormItemTypes.Button,
                            name: "",
                            children: /*#__PURE__*/ React.createElement(DownloadSvgIcon, null),
                            columnSize: 0,
                            variant: "outlined",
                            color: 'secondary'
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(ShareLineSvgIcon, null),
                            columnSize: 0,
                            variant: 'outlined',
                            color: 'secondary'
                        }, {
                            type: FormItemTypes.Button,
                            name: "",
                            children: /*#__PURE__*/ React.createElement(PrintSvgIcon, null),
                            columnSize: 0,
                            variant: "outlined",
                            color: 'secondary'
                        }, {
                            type: FormItemTypes.Box,
                            name: "",
                            columnSize: 0,
                            height: "100%",
                            width: "2px",
                            bgcolor: "rgba(0,0,0,0.1)",
                            mx: 1
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            children: 'Save',
                            columnSize: 0,
                            variant: 'contained',
                            color: 'primary',
                            onClick: function () { return 'submit'; }
                        }]
                }]
        }, isFormVisible ? {
            type: FormItemTypes.Tabs,
            name: "Stepper",
            label: "",
            value: "0",
            tabs: tabs,
            valueExpr: "id",
            displayExpr: "label",
            columnSize: 12,
            sx: {
                px: 2,
                gap: 2
            },
            stackContainerProps: {
                sx: {
                    mb: {
                        xs: 7.5,
                        sm: 0
                    }
                }
            }
        } : null, {
            type: FormItemTypes.ContainerItem,
            name: 'ButtonContainer',
            spacing: 1,
            sx: {
                width: '100%',
                position: 'fixed',
                bottom: 0,
                paddingBottom: 2,
                paddingX: 2,
                right: 7,
                borderTop: "1px solid ".concat(systemColor.grey),
                justifyContent: 'flex-end',
                backgroundColor: '#FFFFFF',
                display: {
                    xs: 'flex',
                    sm: 'none'
                }
            },
            elements: [{
                    type: FormItemTypes.Button,
                    name: '',
                    children: 'Save',
                    columnSize: 0,
                    variant: 'contained',
                    color: 'primary',
                    onClick: function () { return 'submit'; }
                }],
            columnSize: 12
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, isLoadingState(APIKeys) && /*#__PURE__*/ React.createElement(LinearProgress, {
        sx: {
            mt: 0.6
        }
    }), /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        gridSpacing: 0,
        createKey: SpareIssueReturnKeys.Create
        // createFormAPI={CreateWorkPurchaseInvoiceAPICall}
        ,
        createRequest: {
            RecordedBy: crud === null || crud === void 0 || (_crud$profilePersonal = crud.profilePersonalDetails) === null || _crud$profilePersonal === void 0 || (_crud$profilePersonal = _crud$profilePersonal.data) === null || _crud$profilePersonal === void 0 ? void 0 : _crud$profilePersonal.IdentityId,
            Attachments: [],
            TotalAmount: 0,
            // ParentOrganizationId: UserParentOrganization ?? '',
            // OrganizationId: UserOrganization ?? '',
            DocumentDate: new Date().toISOString(),
            Status: "Draft",
            Type: "WorkPurchaseInvoice"
        },
        mode: "edit"
        // getFormAPI={GetWorkPurchaseOrderDetailsAPICall}
        // getKey={WorkPurchaseInvoiceKeys?.Get}
        // getRequest={{ PurchaseOrderId: id }}
        // updateFormAPI={CreateWorkPurchaseInvoiceAPICall}
        // updateRequest={{ PurchaseOrderId: id ?? '' }}
        ,
        onClose: function () {
            dispatch(showNewNotification({
                isOpen: true,
                title: 'Success',
                message: 'Saved Successfully',
                type: 'success'
            }));
            navigate(-1);
        }
    }));
};
export default CreateSpareIssueReturn;
